var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"baikexiangqing"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.baikeData.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.baikeData.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }